export default __webpack_public_path__ + "static/media/o_wdt_c_2.7ea3373e.mp3";